/**
 * Format area value with appropriate unit
 */
export function formatArea(area: number | string): string {
  const numericArea = typeof area === "string" ? parseFloat(area) : area;

  if (isNaN(numericArea) || numericArea <= 0) {
    return "";
  }

  return `${numericArea.toLocaleString()} м²`;
}
